<template>
  <v-dialog v-model="dialog" persistent width="60%">
    <v-card>
      <v-toolbar flat class="k-orange-linear">
        <v-toolbar-title class="white--text pl-4 py-3">
          Plantillas de respuesta
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="px-0">
        <v-layout row wrap py-2>
          <v-flex xs12>
            <data-table
              search-fields="name"
              :url="url"
              fields="name,text,channel"
              content="answerTemplatesList"
              :filters="filters"
              :search-on-create="false"
              :bus="bus"
              :limit="10" @close="dialog = false">
              <template slot="navigation-bar">
                <v-flex md9 pr-1>
                  <v-text-field
                    v-model="filters.search"
                    label="Buscar..."
                    color="black"
                    class="elevation-0 grey-filter"
                    solo>
                  </v-text-field>
                </v-flex>
                <v-flex md3 pl-1>
                  <v-select
                    v-model="filters.category"
                    :items="categories"
                    color="grey"
                    class="elevation-0 grey-filter"
                    autocomplete
                    solo>
                  </v-select>
                </v-flex>
              </template>
            </data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout>
          <v-flex xs12 pr-4 text-xs-right>
            <v-btn flat color="black" @click="dialog = false">
              CERRAR
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue';
import EventBus from '@/event-bus';
import ChannelMixins from '@/mixins/channelsV2';
import DataTable from '@/components/global/DataTable';
import answerTemplatesList from '@/components/chat_center/AnswerTemplatesList';

Vue.component('answerTemplatesList', answerTemplatesList);

export default {
  mixins: [ChannelMixins],
  components: {
    DataTable,
  },
  created() {
    EventBus.$on('openAnswerTemplates', (channel) => {
      this.channel = channel;
      setTimeout(() => {
        this.dialog = true;
      }, 300);
    });
  },
  destroyed() {
    EventBus.$off('openAnswerTemplates');
  },
  data() {
    const emptySelect = [
      {
        value: '',
        text: 'Categorias',
      },
    ];
    return {
      dialog: false,
      channel: 0,
      cancelToken: this.axios.CancelToken.source(),
      emptySelect,
      categories: emptySelect,
      filters: {
        search: '',
        category: '',
        channel: 0,
        status: 'activo',
      },
      bus: {
        update: 'updateAnswerTemplates',
        clearItems: 'clearAnswerTemplates',
        total: 'totalAnswerTemplates',
      },
      url: 'answer_templates',
    };
  },
  watch: {
    channel(newVal, oldVal) {
      if (newVal !== oldVal) { // verificar el cancel token a ver si se puede saber si fue cancelado
        EventBus.$emit('clearAnswerTemplates');
        this.categories = this.emptySelect;
        this.cancelToken = this.axios.CancelToken.source();
        this.axios.get(`answer_templates/categories?channel=${this.channel}`, {
          cancelToken: this.cancelToken.token,
        }).then((response) => {
          const categories = response.data.map(item => ({
            value: item.category,
            text: item.category,
          }));
          this.categories = this.emptySelect.concat(categories);
        }).catch(() => {});
      }
    },
    dialog(newVal) {
      if (newVal) {
        Object.keys(this.filters).forEach((key) => {
          if (key === 'channel' && this.filters.channel !== this.channel) {
            this.filters.channel = this.channel;
          } else if (key !== 'channel' && this.filters[key]) {
            this.filters[key] = '';
          }
        });
      } else {
        this.cancelToken.cancel('');
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/chat_center/AnswerTemplates.vue